import { connect } from 'react-redux';
import TreatmentInstanceDialog from '../../../components/DailyPlanning/TreatmentInstanceDialog/TreatmentInstanceDialog';
import { hideDialog } from '../../../actions/uiElements';
import { selectTreatmentInstancesWithBands } from '../../../reducers/entities/treatmentInstances/selectors';
import { checkFeatureAccess } from '../../../utils/helpers';
import globals from '../../../globals/communityGlobals';

const mapStateToProps = state => {
  const {
    entities: { treatments },
    uiElements: { dialogs },
    global: { auth },
  } = state;
  const { isFetching, treatment } = treatments.previewed;
  return {
    isFetching,
    treatment,
    treatmentInstances: selectTreatmentInstancesWithBands(state),
    dialogs,
    canAllocateWork: checkFeatureAccess(auth.featureAccessList, globals.applicationFeatureAccesses.canAllocateWork),
    canEditTreaments: checkFeatureAccess(auth.featureAccessList, globals.applicationFeatureAccesses.canEditTreaments),
  };
};

const mapDispatchToProps = dispatch => ({
  hide: id => dispatch(hideDialog(id)),
});

const TreatmentInstanceDialogContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(TreatmentInstanceDialog);

export default TreatmentInstanceDialogContainer;
